import React, { useMemo } from 'react'
import { useTheme } from '@mui/material'
import { XAxis } from 'recharts'
import moment from '@e3dc-react/shell/Libs/moment'
import { useXAxisTicks } from 'src/Libs/chart-kit/cartesian-charts/hooks'
import { AI360ChartDataKeys } from 'src/Libs/ai-360/types'

interface Props {
  dateFrom: Date
  dateTo: Date
}

/**
 * Custom XAxis for AI360 Line chart.
 */
export const XAxisAI360: React.FC<Props> = ({ dateFrom, dateTo }) => {
  const theme = useTheme()

  /* memoize to avoid excessive re-rendering of chart */
  const dateFromMoment = useMemo(() => moment(dateFrom), [dateFrom])
  const dateToMoment = useMemo(() => moment(dateTo), [dateTo])

  const { ticks: xAxisTicks, format: xAxisTicksFormat, interval: xAxisInterval } = useXAxisTicks(dateFromMoment, dateToMoment, 'hour', false, false)
  const lastXAxisTicksIndex = xAxisTicks.length - 1

  return (
    <XAxis
      dataKey={AI360ChartDataKeys.time}
      axisLine={{ stroke: theme.palette.shades.shade03 }}
      tickLine={{ stroke: theme.palette.shades.shade03 }}
      tick={{
        fill: theme.palette.shades.shade02,
        fontSize: theme.typography.caption.fontSize,
        letterSpacing: theme.typography.caption.letterSpacing,
        fontWeight: theme.typography.caption.fontWeight,
      }}
      ticks={xAxisTicks}
      tickFormatter={(value, index) => {
        /* ignore first and last tick (according to design) */
        if (index === 0 || index === lastXAxisTicksIndex) return ''

        /* show 4 hour interval (according to design) */
        if (index % 4 !== 0) return ''

        return `${moment(value).format(xAxisTicksFormat)}`
      }}
      scale={'point'}
      mirror={false}
      interval={xAxisInterval}
    />
  )
}
